import { Component, escapeHtml, register } from './core.js';
import { iconHtml } from './icons.js';
import { cx, pick, mountRoot, bindActions } from './chrome.js';
import { buttonHtml } from './button.js';

const DEFAULTS = { icon: null, title: '', text: '', action: null, size: 'md', onAction: null };

/** Shared markup builder for EmptyState (live and static). */
export function emptyStateHtml(opts) {
	const o = Object.assign({}, DEFAULTS, opts);
	return `<div class="${cx('dfc', 'dfc-empty', 'dfc-size-' + pick(o.size, ['sm', 'md'], 'md'), o.className)}" role="status">`
		+ iconHtml(o.icon, 'dfc-empty-icon')
		+ (o.title ? `<div class="dfc-empty-title">${escapeHtml(o.title)}</div>` : '')
		+ (o.text ? `<p class="dfc-empty-text">${escapeHtml(o.text)}</p>` : '')
		+ (o.action ? `<div class="dfc-empty-action">${buttonHtml({ label: o.action.label, icon: o.action.icon, variant: 'secondary', size: o.size === 'sm' ? 'sm' : 'md', action: o.action.id })}</div>` : '')
		+ '</div>';
}

/**
 * EmptyState: a status region shown when there is nothing to list.
 *
 * new dfc.EmptyState(container, { icon, title, text, action: { id, label }, size: 'sm' | 'md', onAction })
 * Events: action { id, event }
 * Static: dfc.EmptyState.renderStatic(opts) -> HTML string
 */
export class EmptyState extends Component {
	static get componentName() { return 'empty'; }
	defaults() { return Object.assign({}, DEFAULTS); }
	render() { mountRoot(this, emptyStateHtml(this.options)); bindActions(this); }
	static renderStatic(opts = {}) { return emptyStateHtml(opts); }
}

register('emptystate', EmptyState);
